import React from "react";
import BussinessHomeHeader from "./BussinessHomeHeader";
import {
  IonButton,
  IonCheckbox,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
} from "@ionic/react";
import { BhpThemeHeaderWithBack } from "../pages/BussinessHomePage";
import { checkmark, close } from "ionicons/icons";
import { getSessionDetails } from "../common/cookies";
import { useCustomToast } from "../app/hooks";
import axios from "axios";
import {
  IDIGIZEN_BACKEND_URL,
  API_SECURE_KEY,
  recordToSResponse,
} from "../types/constants";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfService from "./TermsOfService";
const TermsAndConditions: React.FC<{
  merchantMode: boolean;
  open: boolean;
  onDidDismiss: () => void;
  merchantPhone?: string;
  shopDomain?: string;
  disableButtons?: boolean;
}> = (props) => {
  const presentToast = useCustomToast();
  const enableButtons = !props?.disableButtons;

  const triggerAcceptBackend = async (status: boolean) => {
    try {
      const req = {
        phone: props.merchantPhone,
        shopDomain: props.shopDomain,
        status: status ? "ACCEPTED" : "REJECTED",
        tosId: props.merchantMode ? 1 : 2,
      };

      const res = await axios.post(
        `${IDIGIZEN_BACKEND_URL}/${recordToSResponse}`,
        req,
        {
          headers: { Authorization: API_SECURE_KEY },
        }
      );
      if (res.status === 200 && res.data.data.status === "OK") {
        //response recorded successfully.
      }
      if (status) {
        props.onDidDismiss();
      }
    } catch (e) {
      presentToast(e);
    }
  };
  const { id } = getSessionDetails();

  const showAcceptReject = (!!id || props.merchantMode) && enableButtons;
  console.log(
    "showAcceptReject",
    showAcceptReject,
    "id : ",
    id,
    " merchantc mode : ",
    props.merchantMode,
    " enable buttons : ",
    enableButtons
  );

  return (
    <IonModal
      isOpen={props.open}
      onDidDismiss={props.onDidDismiss}
      initialBreakpoint={0.5}
      breakpoints={[0, 0.5, 1]}
      data-testid="modal-id"
    >
      <IonHeader>
        <div
          style={{
            paddingTop: "20px",
            textAlign: "center",
            width: "100%",
            fontSize: "1rem",
            fontWeight: "bold",
            paddingBottom: !showAcceptReject ? "10px" : undefined,
            color: "grey",
          }}
        >
          Terms And Conditions
          {!!showAcceptReject && (
            <div style={{ padding: "5px", display: "flex" }}>
              <div style={{ width: "50%" }}>
                <IonButton
                  expand="block"
                  size="small"
                  onClick={() => {
                    triggerAcceptBackend(true);
                  }}
                >
                  {" "}
                  <IonIcon icon={checkmark} slot="start" />I Accept
                </IonButton>
              </div>
              <div style={{ width: "50%" }}>
                <IonButton
                  expand="block"
                  fill="clear"
                  color={"danger"}
                  size="small"
                  onClick={() => {
                    triggerAcceptBackend(false);
                  }}
                >
                  {" "}
                  <IonIcon icon={close} slot="start" />I Do Not Accept
                </IonButton>
              </div>
            </div>
          )}
        </div>
      </IonHeader>
      {/* <BhpThemeHeaderWithBack
        title="Terms & Conditions"
        onBack={props.onDidDismiss}
      /> */}

      <IonContent>
        <div style={{ padding: "5px 10px", fontSize: ".8rem" }}></div>
        <TermsOfService merchantMode={true} />
        <PrivacyPolicy />
      </IonContent>
      <IonFooter>
        <IonButton
          expand="block"
          color={"danger"}
          fill="clear"
          onClick={props.onDidDismiss}
        >
          <IonIcon icon={close} slot="start" />
          Close
        </IonButton>
      </IonFooter>
    </IonModal>
  );
};

export default TermsAndConditions;
